export const blockIconsActionDone = (
	<span className='material-symbols-outlined'>done</span>
);
